import { createContext, useContext } from 'react';

export type ActionHandler = (action_id: string, value?: string) => void;
export const ActionCtx = createContext<ActionHandler | undefined>(undefined);
export function useAction() {
  return useContext(ActionCtx);
}

export type Theme = 'light' | 'dark';

export interface Tokens {
  text: string;
  textMuted: string;
  bg: string;
  surface: string;
  border: string;
  inputBg: string;
  inputBorder: string;
  btnBg: string;
  btnText: string;
  btnBorder: string;
  codeBg: string;
  codeBorder: string;
  mentionBg: string;
  mentionText: string;
  link: string;
}

export const LIGHT: Tokens = {
  text: '#1d1c1d',
  textMuted: '#616061',
  bg: '#ffffff',
  surface: '#ffffff',
  border: '#e8e8e8',
  inputBg: '#ffffff',
  inputBorder: 'rgba(29,28,29,0.3)',
  btnBg: '#ffffff',
  btnText: '#1d1c1d',
  btnBorder: 'rgba(29,28,29,0.3)',
  codeBg: 'rgba(29,28,29,0.04)',
  codeBorder: 'rgba(29,28,29,0.13)',
  mentionBg: 'rgba(18,100,163,0.1)',
  mentionText: '#1264a3',
  link: '#1264a3',
};

export const DARK: Tokens = {
  text: '#d1d2d3',
  textMuted: '#9a9b9e',
  bg: '#1a1d21',
  surface: '#222529',
  border: 'rgba(255,255,255,0.1)',
  inputBg: '#1a1d21',
  inputBorder: 'rgba(255,255,255,0.15)',
  btnBg: '#313338',
  btnText: '#d1d2d3',
  btnBorder: 'rgba(255,255,255,0.15)',
  codeBg: 'rgba(255,255,255,0.06)',
  codeBorder: 'rgba(255,255,255,0.12)',
  mentionBg: 'rgba(91,164,207,0.15)',
  mentionText: '#5ba4cf',
  link: '#5ba4cf',
};

export const THEMES: Record<Theme, Tokens> = { light: LIGHT, dark: DARK };

export const ThemeCtx = createContext<Tokens>(LIGHT);

export function useTokens() {
  return useContext(ThemeCtx);
}
